<template lang="pug">
    v-autocomplete(dense 
        v-model="dataType" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="id" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectValidationType",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
    ],
    data() {
        return {
            dataType: {},
            listData: []
        }
    },
    mounted() {
        this.doLoad();
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    methods: {
        doInit(values){
            this.dataType = values ? values : null;
        },
        doLoad(){
            this.$http.get("/api/parameter/validation-type").then(success => {
                this.listData = success.data;
            });
        },
        onSelect() {
            this.$emit("input", this.dataType);
            this.$emit("select", this.dataType);
            this.$emit("validationType", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataType === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>